import React, { useState, FunctionComponent } from 'react';

import * as styles from './ExportToFile.module.scss';

import { CreateInterRaterReliabilityExportParams } from './ExportToFile';
import {
  Button,
  Heading,
  Text,
  FormContainer,
  FormControl,
  FormLabel,
  RadioButton,
  RadioGroup,
} from 'components/core';

const STAGES = { SCREEN: 'Screen', SELECT: 'Select' };

type InterRaterReliabilityProps = {
  createExport: (
    type: string,
    params: CreateInterRaterReliabilityExportParams
  ) => void;
};

const InterRaterReliabilityForm: FunctionComponent<InterRaterReliabilityProps> = (
  props
) => {
  const { createExport } = props;
  const [stage, setStage] = useState<string>(STAGES.SCREEN);

  const pickStage = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStage(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    gtag('event', 'Export Inter-Rater Reliability', {
      event_category: 'engagement',
      event_label: stage,
    });

    createExport('inter_rater_reliability', {
      stage: stage,
    });
  };

  return (
    <form
      id="inter-rater-reliability"
      onSubmit={handleSubmit}
      className={styles.exportForm}
    >
      <div>
        <div className={styles.exportFormHeader}>
          <Heading type="h5">Inter-rater reliability</Heading>
        </div>
        <FormContainer className={styles.optionsContainer}>
          <FormControl>
            <FormLabel id="exportStage" htmlFor="irr_stage" size="sm">
              Stage
            </FormLabel>
            <RadioGroup
              id="irr_stage"
              name="irr_stage"
              defaultValue={STAGES.SCREEN}
              ariaLabelledBy="exportStage"
              onChange={pickStage}
            >
              <RadioButton value={STAGES.SCREEN}>
                Title and abstract screening
              </RadioButton>
              <RadioButton value={STAGES.SELECT}>Full text review</RadioButton>
            </RadioGroup>
          </FormControl>
          <FormControl className={styles.formatList}>
            <Text>Format</Text>
            <Text>CSV</Text>
          </FormControl>
        </FormContainer>
      </div>
      <div className={styles.exportFormFooter}>
        <Button className={styles.exportFormButton} type="brand">
          Prepare file
        </Button>
      </div>
    </form>
  );
};

export default InterRaterReliabilityForm;
